(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babylu-cupones"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-blc-copy]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const code = btn.dataset.blcCopy;
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          const t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (e2) { /* sin portapapeles */ }
          document.body.removeChild(t);
        }
        const original = btn.textContent;
        btn.textContent = '¡Copiado!';
        btn.classList.add('is-done');
        setTimeout(() => { btn.textContent = original; btn.classList.remove('is-done'); }, 2200);
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-banner-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function partsInZone(date, tz) {
      var f = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short'
      });
      var out = {};
      f.formatToParts(date).forEach(function (p) { out[p.type] = p.value; });
      return out;
    }
    // Diferencia (ms) entre la hora de pared en `tz` y UTC para un instante dado.
    function zoneOffset(date, tz) {
      var p = partsInZone(date, tz);
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      return asUtc - Math.floor(date.getTime() / 1000) * 1000;
    }
    // Convierte una hora de pared (Y,M,D,h,m) en `tz` a timestamp UTC.
    function wallToUtc(y, mo, d, h, mi, tz) {
      var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
      var off = zoneOffset(new Date(guess), tz);
      var ts = guess - off;
      off = zoneOffset(new Date(ts), tz);
      return guess - off;
    }
    var DAYS = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

    function target(el) {
      var tz = el.dataset.tz || 'America/Santiago';
      var time = (el.dataset.weeklyTime || '23:59').split(':');
      if (el.dataset.weekly === 'true') {
        var now = new Date();
        var p = partsInZone(now, tz);
        var wanted = +el.dataset.weekday || 0;
        var today = DAYS[p.weekday.toLowerCase().slice(0, 3)];
        var delta = (wanted - today + 7) % 7;
        var ts = wallToUtc(+p.year, +p.month, +p.day + delta, +time[0], +time[1], tz);
        if (ts <= now.getTime()) ts = wallToUtc(+p.year, +p.month, +p.day + delta + 7, +time[0], +time[1], tz);
        return ts;
      }
      var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(el.dataset.deadline || '');
      if (!m) return null;
      return wallToUtc(+m[1], +m[2], +m[3], +m[4], +m[5], tz);
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function init(el) {
      if (el.dataset.blInit) return;
      el.dataset.blInit = '1';
      var clock = el.querySelector('[data-bl-clock]');
      var d = el.querySelector('[data-bl-d]'), h = el.querySelector('[data-bl-h]');
      var mi = el.querySelector('[data-bl-m]'), s = el.querySelector('[data-bl-s]');
      var ts = target(el);
      if (!ts) return;
      var timer;
      function tick() {
        var left = ts - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          if (el.dataset.weekly === 'true') { ts = target(el); return; }
          clock.hidden = true;
          if (el.dataset.hideWhenDone === 'true') el.hidden = true;
          return;
        }
        var sec = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        mi.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
        clock.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function boot() { document.querySelectorAll('[data-bl-countdown]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-grid-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var timer = null;
    function place() {
      var store = document.querySelector('[data-bl-grid-promo]');
      if (!store) return;
      var items = Array.from(document.querySelectorAll('.product-grid__item')).filter(function (li) { return !li.classList.contains('bl-gpromo__item'); });
      if (!items.length) return;
      document.querySelectorAll('.bl-gpromo__item').forEach(function (el) { el.remove(); });
      var cards = Array.from(store.querySelectorAll('.bl-gpromo__card'));
      cards.forEach(function (card, i) {
        var pos = Math.min(parseInt(card.dataset.position, 10) || 5, items.length);
        var anchor = items[pos - 1];
        if (!anchor) return;
        var li = document.createElement('li');
        li.className = 'product-grid__item bl-gpromo__item';
        li.appendChild(card.cloneNode(true));
        anchor.insertAdjacentElement('afterend', li);
      });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(place, 120); }
    function boot() {
      place();
      var first = document.querySelector('.product-grid__item');
      var list = first && first.parentElement;
      if (list && !list.dataset.blPromoObserved) {
        list.dataset.blPromoObserved = '1';
        new MutationObserver(function (m) {
          if (m.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && !n.classList.contains('bl-gpromo__item'); }); })) schedule();
        }).observe(list, { childList: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class BlHero {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-bl-track]');
        if (!this.track || root.dataset.blInit) return;
        root.dataset.blInit = '1';
        this.slides = Array.from(this.track.querySelectorAll('[data-bl-slide]'));
        this.dots = Array.from(root.querySelectorAll('[data-bl-dot]'));
        this.index = 0;
        this.timer = null;
        this.settle = null;
        this.interval = (parseFloat(root.dataset.interval) || 6) * 1000;
        if (this.slides.length < 2) return;

        root.querySelector('[data-bl-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        root.querySelector('[data-bl-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.sync(), 90);
        }, { passive: true });
        root.addEventListener('mouseenter', () => this.stop());
        root.addEventListener('mouseleave', () => this.start());
        root.addEventListener('focusin', () => this.stop());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.start();
      }
      get reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
      go(i, manual) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
        this.paint();
        if (manual) this.start();
      }
      sync() {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i !== this.index && this.slides[i]) { this.index = i; this.paint(); }
      }
      paint() {
        this.dots.forEach((dot, i) => {
          const on = i === this.index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      start() {
        this.stop();
        if (this.reduced || this.root.dataset.autoplay !== 'true') return;
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    }

    function boot() { document.querySelectorAll('[data-bl-hero]').forEach((el) => new BlHero(el)); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    // En el editor: al seleccionar una diapositiva, desplazarse hasta ella.
    document.addEventListener('shopify:block:select', (e) => {
      const slide = e.target.closest('[data-bl-slide]');
      const track = slide?.closest('[data-bl-track]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRail(root) {
      if (root.dataset.blInit) return;
      root.dataset.blInit = '1';
      var track = root.querySelector('[data-bl-track]');
      var prev = root.querySelector('[data-bl-prev]');
      var next = root.querySelector('[data-bl-next]');
      if (!track || !prev || !next) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function step() { return Math.max(track.clientWidth * 0.9, 200); }
      function paint() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    }
    function boot() { document.querySelectorAll('[data-bl-rail]').forEach(initRail); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);

    // El quick-add nativo de Horizon obtiene la URL del producto desde <product-card>.
    // Nuestras tarjetas no usan ese elemento, así que le enseñamos a leerla desde .bl-prod.
    if (window.customElements) {
      customElements.whenDefined('quick-add-component').then(function () {
        var Cls = customElements.get('quick-add-component');
        var proto = Cls && Cls.prototype;
        var desc = proto && Object.getOwnPropertyDescriptor(proto, 'productPageUrl');
        if (!desc || !desc.get || proto.__blPatched) return;
        proto.__blPatched = true;
        Object.defineProperty(proto, 'productPageUrl', {
          configurable: true,
          get: function () {
            var card = this.closest('.bl-prod');
            var link = card && card.querySelector('a.bl-prod__media[href]');
            if (link) return link.href;
            return desc.get.call(this);
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
